import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getInitiateIvSelector } from '../../procedures/initiateIv/selectors'
import { IInitiateIvState } from '../../procedures/initiateIv/store/initiateIv.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addInitiateIvItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const initiateIvState: IInitiateIvState = yield select(getInitiateIvSelector)
  const {
    pta,
    addToTimeline,
    site,
    sitePNNV,
    size,
    iVType,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
  } = initiateIvState
  if (addToTimeline) {
    const clientCorrelationId = generateClientCorrelationId(
      nemsisCodeOptions,
      TimelineConstants.INITIATE_IV_PROCEDURE,
      site?.name || '',
      {
        filter1: null,
        filter2: null,
        filter3: null,
      },
      key
    )
    const assessedByLabel = assessedBy?.name || ''
    const siteLabel = site ? site?.name || '' : sitePNNV?.name || ''
    const typeLabel = iVType?.name || ''
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Initiate IV',
      eventSubHeader: `By ${assessedByLabel}, Site: ${siteLabel}, Gauge: ${size}, Type: ${typeLabel},
      Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_INITIATE_IV_PROCEDURE_ITEM,
      defaultHref: TabConstants.INITIATE_IV_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addInitiateIvItemSaga() {
  yield takeLatest([TimelineConstants.ADD_INITIATE_IV_ITEM], addInitiateIvItem)
}
